// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';
import { MdAccountCircle } from 'react-icons/md';

export default ({ btn_ref, session = {} }) => {

  const { uid, name, logged_out } = session;

  const authenticated = (!!uid && logged_out!==true);

  const caption = () => `${ (!!authenticated) ? name.split(' ')[0] : 'Sign In' }`;

  return (<div ref={btn_ref} className='Nav-Accounts'>
    <Link to='/login'>
      <MdAccountCircle className='icon'/>
      <div className="Nav-Account-Label-SM">Hello, {caption()}</div>
      <div className="Nav-Account-Label-BD">Accounts & Lists</div>
    </Link>
    </div>
  )

};
